
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class VolcanicAshEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
        const spacing = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const speed = (0.2 + layerIndex * 0.1) * 300 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        for (let x = x1; x <= x2; x += spacing / 2) {
            const driftP = this.pseudoRandom(x);
            const scrollY = (time * speed) % spacing;
            const scrollX = (time * speed * 0.2) % spacing;
            
            for (let y = y1; y <= y2; y += spacing / 2) {
                const size = (1 + driftP * 4) * scale;
                const rot = time * (0.1 + driftP);
                
                const draw = () => {
                    ctx.save();
                    ctx.translate(x + scrollX, y - scrollY);
                    ctx.rotate(rot);
                    ctx.fillRect(-size/2, -size/2, size, size);
                    ctx.restore();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
